import { ArrowDownToLine, Boxes, ListChecks, PackageCheck, PackageOpen, ScanSearch, Truck } from 'lucide-react';
import {
  OPERATOR_FLOW,
  OPERATOR_FLOW_LABELS,
  OPERATOR_FLOW_PATHS,
} from '../../features/operator/operatorConstants';
import { returnToOf } from '../../features/operator/operatorUtils';

/** Each flow's icon, for its card on Inicio. */
export const OPERATOR_FLOW_ICONS = {
  [OPERATOR_FLOW.RECEIVING]: PackageOpen,
  [OPERATOR_FLOW.PUTAWAY]: ArrowDownToLine,
  [OPERATOR_FLOW.PICKING]: ListChecks,
  [OPERATOR_FLOW.PACKING]: PackageCheck,
  [OPERATOR_FLOW.DISPATCH]: Truck,
  [OPERATOR_FLOW.KITS]: Boxes,
  [OPERATOR_FLOW.STOCK]: ScanSearch,
};

const HOME = { title: 'Inicio', backTo: null };

/**
 * The top bar's title for a path, and where its back arrow goes: a flow's
 * queue goes back to Inicio, one of its tasks back to the queue — or, opened
 * as a detour (`returnState`), back where it was opened from.
 *
 * @param {string} pathname
 * @param {*} [state] - The location's router state.
 * @returns {{title: string, backTo: string|null}}
 */
export const operatorScreenOf = (pathname, state) => {
  if (pathname === '/dashboard') return HOME;

  const match = Object.entries(OPERATOR_FLOW_PATHS).find(
    ([, path]) => pathname === path || pathname.startsWith(`${path}/`)
  );
  if (!match) return { title: 'NinjaHubs', backTo: '/dashboard' };

  const [flow, path] = match;
  const back = returnToOf(state)?.to;
  return { title: OPERATOR_FLOW_LABELS[flow], backTo: back || (pathname === path ? '/dashboard' : path) };
};
